import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, Select, Input, Button, InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const PatchExtraValueModal = ({
  schema,
  extraKey,
  min,
  patchContractValue,
  openExtraValueModal,
  setOpenExtraValueModal
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const fieldType = {
    String:
      extraKey && schema[extraKey]?.enum ? (
        <Select style={{ width: 250 }}>
          {extraKey &&
            schema[extraKey]?.enum &&
            schema[extraKey]?.enum.map((enums) => (
              <Option key={enums} value={enums}>
                {t(`settings.tickets.enums.${enums}`)}
              </Option>
            ))}
        </Select>
      ) : (
        <Input />
      ),
    Mixed: <InputNumber />,
    Number:
      extraKey && schema[extraKey]?.enum ? (
        <Select style={{ width: 250 }}>
          {extraKey &&
            schema[extraKey]?.enum &&
            schema[extraKey]?.enum.map((enums) => (
              <Option key={enums} value={enums}>
                {t(`settings.tickets.enums.${enums}`)}
              </Option>
            ))}
        </Select>
      ) : (
        <InputNumber min={min} defaultValue={min} />
      )
  };

  const handleClose = () => {
    form.resetFields();
    setOpenExtraValueModal(false);
  };

  return (
    <>
      <Modal
        title={t(`settings.tickets.modal.${extraKey}`)}
        centered
        open={openExtraValueModal}
        onCancel={() => handleClose()}
        width={750}
        footer={false}
      >
        <Form form={form} layout="vertical" onFinish={patchContractValue}>
          <Form.Item
            label={t(`contracts.form.${extraKey}`)}
            name={[extraKey]}
            rules={[{ required: true }]}
          >
            {extraKey && fieldType[schema[extraKey]?.type]}
          </Form.Item>
          <Form.Item style={{ marginTop: 25 }}>
            <Button type="primary" htmlType="submit">
              {t('buttons.save')}
            </Button>
            <Button type="link" danger onClick={handleClose}>
              {t('buttons.cancel')}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

PatchExtraValueModal.propTypes = {
  schema: PropTypes.shape({}).isRequired,
  openExtraValueModal: PropTypes.bool.isRequired,
  extraKey: PropTypes.string.isRequired,
  setOpenExtraValueModal: PropTypes.func.isRequired,
  patchContractValue: PropTypes.func.isRequired,
  min: PropTypes.number
};
PatchExtraValueModal.defaultProps = {
  min: null
};

export default PatchExtraValueModal;
